import { BridgeFiatRail } from 'services/merchants/types';

import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'pages.refundAccount.transactions.topUpDetails';

export const BREADCRUMBS = [
  [`${NAMESPACE}.breadcrumbs.merchantAccounts`, 'Merchant Accounts'],
  [`${NAMESPACE}.breadcrumbs.accountSettings`, 'Account Settings'],
  [`${NAMESPACE}.breadcrumbs.refundAccount`, 'Refund Account'],
  [`${NAMESPACE}.breadcrumbs.topup`, 'Top Up'],
];
export const LABELS = makeLabels(
  {
    PAGE_TITLE: ['title', 'Top Up'],
    TOPUP_SECTION_TITLE: ['topupSectionTitle', 'Top Up Details'],
    TOPUP_SECTION: {
      ID: ['topupSection.id', 'Top Up ID'],
      AMOUNT: ['topupSection.amount', 'Amount'],
      RECEIVED_AT: ['topupSection.receivedAt', 'Received At'],
      STATUS: ['topupSection.status', 'Status'],
      BRIDGE_ACTIVITY_ID: ['topupSection.bridgeActivityId', 'Bridge Activity ID'],
    },
    SOURCE_SECTION_TITLE: ['sourceSectionTitle', 'Source'],
    SOURCE_SECTION: {
      PAYMENT_RAIL: ['sourceSection.paymentRail', 'Payment Rail'],
      SENDER_NAME: ['sourceSection.senderName', 'Sender Name'],
      SENDER_ROUTING_NUMBER: ['sourceSection.senderRoutingNumber', 'Sender Routing Number'],
      TRANSFER_MEMO: ['sourceSection.transferMemo', 'Transfer Memo'],
      TRACE_NUMBER: ['sourceSection.traceNumber', 'Trace Number'],
    },
    PAYMENT_RAIL: {
      [BridgeFiatRail.ACH]: ['paymentRail.ach', 'ACH'],
      [BridgeFiatRail.ACH_SAME_DATE]: ['paymentRail.achSameDay', 'ACH Same Day'],
      [BridgeFiatRail.WIRE]: ['paymentRail.wire', 'Wire'],
      [BridgeFiatRail.SEPA]: ['paymentRail.sepa', 'SEPA'],
      [BridgeFiatRail.SWIFT]: ['paymentRail.swift', 'SWIFT'],
      [BridgeFiatRail.SPEI]: ['paymentRail.spei', 'SPEI'],
      [BridgeFiatRail.PIX]: ['paymentRail.pix', 'PIX'],
      [BridgeFiatRail.BRE_B]: ['paymentRail.breB', 'Bre-B'],
    },
    ERRORS: {
      FETCHING_TRANSACTION: ['errors.fetchingTransaction', 'Error fetching transaction'],
    },
  },
  NAMESPACE,
);
